<template>
  <Layout>
    <div class="mc-fleet-task">
      <PageHeader :title="title" :sub-title="subTitle">
        <template #afterTitle v-if="metadata?.total_count > 0">
          <div class="d-flex gap-2">
            <McButton
              variant="primary"
              :text="$t('global.addField')"
              icon="icon-fill_plus"
              @click="$router.push({ name: 'Invoice Create' })"
            />
          </div>
        </template>
      </PageHeader>
      <div v-show="isTableDataAvailable">
        <div class="d-flex justify-content-end mb-2">
          <a
            class="btn btn-outline-primary ms-2"
            href="javascript: void(0);"
          >
            <i class="mc-fa icon-outline_filter"></i> Filter
          </a>
        </div>
        <b-row class="payment-status">
          <b-col sm="8">
            <div class="card p-3">
              <b-row>
                <b-col sm="6">
                  <div class="d-flex justify-content-between">
                    <div>
                      <p class="payment-status__status-text">
                        Belum Dibayarkan <i class="payment-status__status-text-icon icon-outline_chevron-right"></i>
                      </p>
                      <p class="mb-0"><span class="payment-status__amount">{{ dummyPrice.toLocaleString() }}</span> <span class="payment-status__currency">Rupiah</span></p>
                    </div>
                    <div>
                      <div class="payment-status__icon payment-status__icon--blue">
                        <i class="payment-status__icon-image icon-outline_file"></i>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col sm="6" style="border-left: 1px solid #99A1B1">
                  <div class="d-flex justify-content-between">
                    <div>
                      <p class="payment-status__status-text">
                        Sudah Dibayarkan <i class="payment-status__status-text-icon icon-outline_chevron-right"></i>
                      </p>
                      <p class="mb-0"><span class="payment-status__amount">{{ dummyPrice.toLocaleString() }}</span> <span class="payment-status__currency">Rupiah</span></p>
                    </div>
                    <div>
                      <div class="payment-status__icon payment-status__icon--green">
                        <i class="payment-status__icon-image icon-outline_file-text"></i>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="4">
            <div class="card p-3">
              <div class="d-flex justify-content-between">
                <div>
                  <p class="payment-status__status-text">
                    Jatuh Tempo <i class="payment-status__status-text-icon icon-outline_chevron-right"></i>
                  </p>
                  <p class="mb-0"><span class="payment-status__amount">10</span> <span class="payment-status__currency">Invoice</span></p>
                </div>
                <div>
                  <div class="payment-status__icon payment-status__icon--orange">
                    <i class="payment-status__icon-image icon-outline_timer"></i>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <McTable
          withCard
          searchable
          stickyHeader
          bulkDeleteApi
          hasEmit:deleteError
          hasCheckbox
          hasDelete
          :hasSelectAll="false"
          :fields="fields"
          :apiClient="apiClient"
          @available-change="handleDataAvailable"
        >
          <template #before-table="{ isSelected, showDeleteModal }">
            <div class="d-flex justify-content-between mb-3">
              <McInlineFilter
                :filterItems="inlineFilterItems"
                :activeKeys="activeFilters['status.name']"
                @update:activeKeys="
                  handleChangeActiveFilters([{ key: 'status.name', values: $event }])
                "
              />
  
              <div class="d-flex gap-2">
                <!-- TODO: table filter if mockup done -->
                <!-- <McTableFilter
                  :activeFilters="activeFilters"
                  :parseFilterDataMappings="parseFilterDataMappings"
                  @submit="handleChangeActiveFilters"
                >
                  <template
                    #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }"
                  >
                    <InputTableFilter
                      :formValues="formValues"
                      :fullObjects="fullObjects"
                      @update:formValues="updateFormValues($event)"
                      @update:fullObjects="updateFullObjects($event)"
                    />
                  </template>
                </McTableFilter> -->
  
                <ActionsDropdown
                  v-if="false"
                  :disabled="!isSelected"
                  :actionHandlers="{ handleDelete: showDeleteModal }"
                />
  
                <McButton
                  v-if="isSelected"
                  @click="showDeleteModal"
                  variant="secondary-red"
                  :text="$t('global.delete')"
                  icon="icon-outline_trash"
                />
              </div>
            </div>
          </template>
          <!-- status -->
          <template #cell(status.name)="{ item }">
            <template>
              <FieldStatus :item="item" />
            </template>
          </template>
  
          <!-- date -->
          <template #cell(date)="{ value }">
            <template v-if="value">
              <div>{{ formatIndexDate(value).date }}</div>
            </template>
            <template v-else>-</template>
          </template>
  
          <!-- latest_exported_on -->
          <template #cell(latest_exported_on)="{ value }">
            <template v-if="value">
              <div>{{ formatIndexDate(value).date }}</div>
              <div class="__time">{{ formatIndexDate(value).time }}</div>
            </template>
            <template v-else>-</template>
          </template>
  
          <!-- created on -->
          <template #cell(created_on)="{ value }">
            <div>{{ formatIndexDate(value).date }}</div>
            <div class="__time">{{ formatIndexDate(value).time }}</div>
          </template>
  
          <!-- vehicle.license_plate -->
          <template #cell(vehicle.license_plate)="{ value }"> {{ value || '-' }} </template>
  
          <!-- driver_user -->
          <template #cell(driver_user.name)="{ value }"> {{ value || '-' }} </template>
        </McTable>
      </div>
      <div class="card" v-show="!isTableDataAvailable">
        <div class="empty-state-container card-body">
          <img src="@/assets/images/no-data-illustration.png"/>
          <strong>{{ $t("global.title.emptyData", { feature: 'invoice'}) }}</strong>
          <p class="mb-4">{{ $t("global.subtitle.emptyData", { feature: 'invoice'}) }}</p>
          <McButton
            variant="primary"
            :text="`${$t('global.action.create')} Invoice`"
            icon="icon-fill_plus"
            @click="$router.push({ name: 'Invoice Create' })"
          />
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McTable from '@/components/McTable'
import McButton from '@/components/McButton'
import McInlineFilter from '@/components/McInlineFilter'
import { MixPanel } from '@/mixin/mixpanel'
import * as Invoice from '@/services/rest-api/lib/invoice/invoice'
import { fields } from './lib/fields/invoiceListFields'
import inlineFilterItems from './lib/constants/inline-filter-items'
import FieldStatus from './components/Field/Status.vue'
import moment from 'moment'
moment.locale('id')
export default {
  page: {
    title: 'Invoice List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McTable,
    McButton,
    McInlineFilter,
    FieldStatus,
  },
  mixins: [MixPanel, fields],
  data() {
    return {
      inlineFilterItems,
      activeFilters: {},
      params: {},
      metadata: null,
      isTableDataAvailable: true,
      // TODO: remove later if not needed
      dummyPrice: 5000000
    }
  },
  computed: {
    title() {
      return this.$t('invoice.title.invoiceList')
    },
    subTitle() {
      return this.$t('invoice.subtitle.invoiceList')
    },
    customHandlers() {
      return {
        handleClickRow: this.handleClickRow,
      }
    },
    downloadPageOptions() {
      return [
        { label: this.$t('global.currentPage'), amount: this.metadata?.count, key: 'current_page' },
        { label: this.$t('global.allPages'), amount: this.metadata?.total_count, key: 'all' },
      ]
    },
    apiClient() {
      let getInvoices = Invoice.get(null, this.handleSetParams, this.handleSetMetadata)

      if (Object.keys(this.activeFilters).length > 0) {
        const queryParamFilters = []

        // TODO: map filter to API call later
        // mapping the activeFilters to be sent as query params
        // Object.keys(this.activeFilters).forEach((key) => {
          // let filterValue = this.activeFilters[key]

          // add hours directly since backend doesn't support date only filter for created_on variable
          // if (key === 'created_on:gte') {
          //   filterValue = new Date(filterValue)
          //   filterValue.setHours(0, 0, 0)
          //   filterValue = filterValue.toISOString()
          // } else if (key === 'created_on:lte') {
          //   filterValue = new Date(filterValue)
          //   filterValue.setHours(23, 59, 59)
          //   filterValue = filterValue.toISOString()
          // } else if (key === 'latest_exported_on:is') {
          //   if (!filterValue) return
          //   key = `latest_exported_on:${filterValue}`
          //   filterValue = null
          // }

          // const filter = filterMappings[key]?.(key, filterValue) ?? undefined
          // queryParamFilters.push(filter)
        // })

        getInvoices = Invoice.get(
          queryParamFilters,
          this.handleSetParams,
          this.handleSetMetadata
        )
      }

      const client = {
        get: getInvoices,
      }

      return client
    },
  },
  methods: {
    // formatIndexDate,
    handleClickRow(item) {
      this.$router.push({ name: 'Detail Cost Management', params: { id: item.id } })
    },
    handleDeleteError(errors) {
      // let errorMessage = 'Gagal dihapus, Ada status Dokumen Biaya selain Draf.'

      // // TODO: Change the condition to error.message == 'invalid status', after the APIClient error return refactored to return both error message and error fields.
      // if (errors.status === 400 && errors.errors['ids.0'][0] === 'invalid status') {
      //   errorMessage = toastErrors['failed-to-bulk-delete']
      // }

      // this.$mcToast.error(errorMessage)
    },
    handleChangeActiveFilters(filters) {
      /*
        filters is Array of Object
        example:
        [
          {
            key: 'created_on:lte',
            values: '2023-08-29T17:00:00Z'
          }
        ]
        */

      filters.forEach((filter) => {
        // to reset the filter values
        this.$delete(this.activeFilters, filter.key)

        // to prevent set the filter in activeFilters if values are null or undefined
        if (filter.values === null || filter.values === undefined) return
        // to prevent set the filter in activeFilters if values are Array with length equal to 0
        if (Array.isArray(filter.values) && filter.values.length === 0) return

        // set the key and values in activeFilters
        this.$set(this.activeFilters, filter.key, filter.values)
      })
    },
    handleSetParams(params) {
      this.params = params
    },
    handleSetMetadata(metadata) {
      this.metadata = metadata
    },
    handleDataAvailable(available) {
      this.isTableDataAvailable = available
    }
  },
}
</script>
<style lang="scss">
.empty-state-container {
  margin: 20px 0;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 300px;
  }
  strong {
    color: $mep-color-text !important;
    font-size: 16px;
    line-height: 24px;
  }
  p {
    color: $mep-color-text !important;
    margin-top: 10px;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
  }
}

.mc-dropdown {
  .dropdown-item:hover,
  .dropdown-item:focus {
    background-color: $mep-primary-400 !important;
    color: $white;
  }
}
.__time {
  color: $mep-color-text-200;
}

.payment-status {
  &__status-text {
    display: flex;
    align-items: center;
    font-size: 13px;
  }

  &__status-text-icon {
    font-size: 18px;
  }

  &__amount {
    font-size: 20px;
  }

  &__currency {
    color: #67718B;
  }

  &__icon {
    height: 32px;
    width: 32px;
    border-radius: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    &--blue {
      background-color: #1c74da;
    }

    &--green {
      background-color: #137c55;
    }

    &--orange {
      background-color: #ff8a00;
    }
  }

  &__icon-image {
    color: white;
    font-size: 20px;
  }
  
  &__icon-image::before {
    color: white;
  }
}
</style>
